export { default as  NikoPatientListTemplate} from './NikoPatientListTemplate';
export { default as  NikoPatientPreviewTemplate} from './NikoPatientPreviewTemplate';
export { default as  NikoPatientTemplateListTemplate } from './NikoPatientTemplateListTemplate';